
export function uiReducer (state,action) {
  switch(action.type){
      case 'ui': return state = action.payload
      default: return state
  }
}

export default uiReducer